import { render } from "./Logo.vue?vue&type=template&id=4f63adbf"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=4f63adbf&lang=css"
script.render = render

export default script